import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "dateColumn" }
const _hoisted_2 = { class: "amountText" }
const _hoisted_3 = { class: "amountText" }
const _hoisted_4 = { class: "dataColumn" }
const _hoisted_5 = { class: "amountText" }
const _hoisted_6 = { class: "statusText" }

import { CardDataItem } from '@/view/fundHistory/supportScript';


export default /*@__PURE__*/_defineComponent({
  __name: 'flowLogCard',
  props: {
    cardData: {}
  },
  setup(__props: any) {

const props = __props



return (_ctx: any,_cache: any) => {
  const _component_van_col = _resolveComponent("van-col")!
  const _component_van_row = _resolveComponent("van-row")!

  return (_openBlock(), _createBlock(_component_van_row, { class: "rowField" }, {
    default: _withCtx(() => [
      _createVNode(_component_van_col, { span: "10" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.$t(_ctx.cardData?.type || '')), 1),
            _createElementVNode("div", null, _toDisplayString(_ctx.cardData?.createTime), 1)
          ])
        ]),
        _: 1
      }),
      _createVNode(_component_van_col, {
        span: "6",
        class: "amountColumn"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.cardData.amount), 1)
        ]),
        _: 1
      }),
      _createVNode(_component_van_col, { span: "8" }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, _toDisplayString(_ctx.$t('funds.balance')), 1),
            _createElementVNode("div", _hoisted_6, _toDisplayString(_ctx.cardData?.afterBalance), 1)
          ])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})